// Lista de idiomas predefinidos
export const PREDEFINED_LANGUAGES = [
  'Español',
  'Inglés',
  'Francés',
  'Alemán',
  'Italiano',
  'Portugués',
  'Catalán',
  'Euskera',
  'Gallego',
  'Árabe',
  'Chino',
  'Japonés',
  'Coreano',
  'Ruso',
  'Hindi',
  'Bengalí',
  'Urdu',
  'Persa',
  'Turco',
  'Neerlandés',
  'Sueco',
  'Danés',
  'Noruego',
  'Finés',
  'Polaco',
  'Checo',
  'Eslovaco',
  'Húngaro',
  'Rumano',
  'Búlgaro',
  'Croata',
  'Serbio',
  'Esloveno',
  'Estonio',
  'Letón',
  'Lituano',
  'Maltés',
  'Griego',
  'Hebreo',
  'Tailandés',
  'Vietnamita',
  'Indonesio',
  'Malayo',
  'Tagalo',
  'Suajili',
  'Afrikáans',
  'Zulú',
  'Xhosa',
  'Yoruba',
  'Igbo',
  'Hausa',
  'Amárico',
  'Somalí',
  'Kurdo',
  'Azerbaiyano',
  'Georgiano',
  'Armenio',
  'Kirguís',
  'Uzbeko',
  'Turcomano',
  'Mongol',
  'Nepalí',
  'Cingalés',
  'Birmano',
  'Jemer',
  'Lao',
  'Tamil',
  'Telugu',
  'Canarés',
  'Malayalam',
  'Gujarati',
  'Panyabí',
  'Oriya',
  'Asamés',
  'Maratí',
  'Sánscrito',
  'Tibetano',
  'Dzongkha',
  'Uigur',
  'Kazajo',
  'Tayiko',
  'Pastún',
  'Sindhi',
  'Kurdo Sorani',
  'Arameo',
  'Copto',
  'Ge\'ez',
  'Siríaco',
  'Acadio',
  'Sumerio',
  'Armenio Clásico',
  'Eslavo Eclesiástico',
  'Griego Antiguo',
  'Latín',
  'Inglés Antiguo',
  'Francés Antiguo',
  'Alto Alemán Antiguo',
  'Nórdico Antiguo',
  'Gótico',
  'Irlandés Antiguo',
  'Galés Antiguo',
  'Egipcio Antiguo',
  'Hitita',
  'Luvita',
  'Persa Medio',
  'Persa Antiguo',
  'Avestan',
  'Pali',
  'Prakrit',
  'Indoario',
  'Iranio',
  'Celta',
  'Germánico',
  'Itálico',
  'Indoeuropeo',
  'Afroasiático',
  'Semítico',
  'Bereber',
  'Cusita',
  'Oromo',
  'Tigriña',
  'Afar',
  'Siswati',
  'Sesoto',
  'Setswana',
  'Xitsonga',
  'Tshivenda',
  'Ndebele del Sur',
  'Ndebele del Norte',
  'Shona',
  'Kinyarwanda',
  'Kirundi',
  'Luganda',
  'Akan',
  'Ewe',
  'Twi',
  'Fula',
  'Wolof',
  'Dyula',
  'Bambara',
  'Sango',
  'Lingala'
].sort();

// Función para obtener todos los idiomas únicos (predefinidos + existentes)
export const getAllLanguages = (existingLanguages: string[] = []): string[] => {
  const combined = [...PREDEFINED_LANGUAGES, ...existingLanguages];
  return [...new Set(combined)].filter(Boolean).sort();
};